export const actionTypes = {
    SET_ANALYTICS_LIST_DATA: 'SET_ANALYTICS_LIST_DATA',
    SET_ANALYTICS_LIST_CANCEL_TOKEN: 'SET_ANALYTICS_LIST_CANCEL_TOKEN',
    IS_ANALYTICS_LIST_FETCHING: 'IS_ANALYTICS_LIST_FETCHING'
}